// extracted by mini-css-extract-plugin
export var noSpacingBottom = "Text-module--noSpacingBottom--LLjnF";
export var noSpacingTop = "Text-module--noSpacingTop--QPlfL";
export var section = "Text-module--section--Vq45o";
export var spacingLg = "Text-module--spacingLg--iNLhn";
export var text = "Text-module--text--e5Fne";